export default __webpack_public_path__ + "static/envelope-back-1bb91ae66433c5a0bf33e7a92ef21e78.png";